import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from 'antd';

const RDAvatar = ({ text, src, size, shape, icon }) => (
  <Avatar src={src} size={size} shape={shape} icon={icon}>
    {text}
  </Avatar>
);

RDAvatar.defaultProps = {
  text: '',
  src: '',
  size: 'small',
  shape: 'circle',
  icon: undefined,
};

RDAvatar.propTypes = {
  /** text to show on avatar */
  text: PropTypes.string,
  /** The source of the image for an image avatar  */
  src: PropTypes.string,
  /** The size of the avatar */
  size: PropTypes.string,
  /** The shape of avatar */
  shape: PropTypes.string,
  /** Custom icon type for an icon avatar */
  icon: PropTypes.element,
};

export default RDAvatar;
